import { render, staticRenderFns } from "./RFM_standard_analysis.vue?vue&type=template&id=987f5e44&scoped=true"
import script from "./RFM_standard_analysis.vue?vue&type=script&lang=js"
export * from "./RFM_standard_analysis.vue?vue&type=script&lang=js"
import style0 from "./RFM_standard_analysis.vue?vue&type=style&index=0&id=987f5e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f5e44",
  null
  
)

export default component.exports